import React, { memo } from 'react'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import styles from '../styles'
import { TSearchEmptyResultProps } from 'models'

const useStyles = makeStyles(styles)

const SearchEmptyResult: React.FunctionComponent<TSearchEmptyResultProps> = ({
	query,
	textFontSize,
}) => {
	const classes = useStyles()
	const { t } = useTranslation()
	const stylesNewSearchContainer =
		textFontSize === 'small' ? { paddingTop: '0%' } : {}
	const stylesNewSearchText =
		textFontSize === 'small' ? { fontSize: 12, lineHeight: '16px' } : {}
	return (
		<div
			className={classNames(classes.newSearchContainer)}
			style={stylesNewSearchContainer}
		>
			<div
				className={classNames(classes.newSearchText)}
				style={stylesNewSearchText}
			>
				{t(`We couldn't find anything\nTry to refine your search term`)}
			</div>
		</div>
	)
}

export default memo(SearchEmptyResult)
